<template>
	<div class="homes">
		<div class="tops"></div>
		<ul>
			<li class="items" >
				<router-link to="examine">
					<img src="../assets/huiyi.png" alt="">
					<span>访客入矿审核</span>
				</router-link>				
			</li>
			<li class="items">
				<router-link to="vehicle_review">
					<img src="../assets/cars.png" alt="">
					<span>运输入矿审核</span>
				</router-link>
			</li>			
			<li class="items">
				<router-link to="material_examine">
					<img src="../assets/park.png" alt="">
					<span>物资出矿审核</span>
				</router-link>
			</li>
		</ul>
	</div>
</template>
<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {
			document.title = '预约系统'

		},
		beforeDestroy() {

		},
		methods: {

		}
	}
</script>
<style scoped lang="less">
	.homes{
		background: #F7F7F7;
		height: 100vh;
	}
	.tops{
		background:url(../assets/banner.png) no-repeat;
		background-size: 100% 100%;
		width: 100%;
		height: 430px;
	}
	ul {
		display: flex;
		align-items: center;
		flex-direction: row;
		flex-wrap: wrap;
		padding: 40px;
		li{
			display: flex;
			flex-direction: column;
			justify-content: center;
			width:325px;
			text-align: center;
			background: #ffffff;
			border-radius: 10px;
			margin-bottom:20px;
			padding: 20px 0;
			a{
				width: 100%;
				height: 100%;
				// display: inline-block;
				display: flex;
				flex-direction: column;
				justify-content: center;
			}
			&:nth-child(2n+1){
				margin-right: 20px;
			}
			img{
				width: 120px;
				height: 120px;
				display: inline-block;
				margin: 0 auto;
			}
			span{
				font-size: 32px;
				font-weight: bold;
				margin-top: 20px;
				color: #666;
			}
		}
	}
	a:-webkit-any-link:active{
		color: #666;
	}
</style>
